import FieldMixins from './mixins/field_mixin.js';

const Rating = Vue.extend({
  mixins: [FieldMixins],

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               :disabledFieldLayout='disabledFieldLayout'
               ref='fieldView'>
      <template slot='content'>
        <div class="edit-content" v-if='editing'>
          <div class="justify-box vertical-top">
            <div class="vertical-top stars-setting">
              <span>最大分数</span>
              <div>
                <input type="number" max=10 min=1
                       :value='field.maximum'
                       @input='updateMaximum' />
                <div class="placeholder">不能超过10</div>
              </div>
              <span>星</span>
            </div>
            <div class="stars-container content">
              <span class='helper-text' v-for='num in field.maximum' :key='num'>
                <i class="slp-star"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="display-content" v-else>
          <span class='helper-text' v-for='index in field.maximum' :key='index'>
            <i class="slp-star"></i>
          </span>
        </div>
      </template>
    </FieldView>
  `,

  created: function() {
    if (this.field.maximum == null) {
      this.field.maximum = 5;
    }
  },

  methods: {
    updateMaximum: function(event) {
      var value;

      value = parseInt(event.target.value || 0);
      this.field.maximum = Math.min(Math.max(value, 1), 10);
    }
  }
});

export default Rating;
